module.exports = __webpack_public_path__ + "static/adventures-of-huckleberry-finn-67dcfc547b98a4cd3e5a4e6e329766b6.jpg";